import React from "react";
import { useState, useContext } from "react";
import {
  formatIndianAmount,
  formatDaysAgo,
  addtoWishlist,
  addtoWishlist_Projects,
  getWishList,
} from "../Services/Helper";
import { useNavigate } from "react-router-dom";
import { ApiContext } from "../Context/Context";
import { LoggedInUserID } from "../Services/Urls";
import { toast } from "react-toastify";
import { PostRecords } from "../Services/ApiCall";
const ProjectsComp = ({ onheartClick, ...data }) => {
  const {
    logindata,
    setlogindata,
    userData,
    setuserData,
    coordinates,
    setcoordinates,

    searchData,
    setsearchData,
    wishlist,
    setWishlist,
  } = useContext(ApiContext);
  const navigate = useNavigate();

  const defaultImage = "assets/img/property/property-22.jpg";

  const imageSrc =
    typeof data?.Images === "string" && data.Images.trim() !== ""
      ? data.Images.split(",")[0].trim()
      : defaultImage;

  const handleNavigate = () => {
    navigate(`/project-details?id=${data?.SocietyID}`);
  };

  const isWishlisted = (data) => {
    return wishlist.some(
      (item) => item?.IsListingID === 2 && item?.ListingID === data?.SocietyID,
    );
  };

  return (
    <div className="col-lg-3 col-md-6 col-sm-6 col-sm-6 col-xs-6">
      <div className="property-card style2 pscard">
        <div className="property-img-slider">
          <img src={imageSrc} alt="Property" />
          <div className="chipps chippss">
            <span className="property-status">
              <i
                onClick={(e) => {
                  e.stopPropagation(); // prevents parent click
                  if (LoggedInUserID == null) {
                    onheartClick();
                  } else {
                    if (!isWishlisted(data)) {
                      let enqBody = [
                        {
                          ListingID: data?.SocietyID,
                          PropertyTypeID: 1,
                          VerticalID: 4,

                         
                          UserName: userData?.User,
                          UserID: userData?.UserID,
                          UserMobile: userData?.Mobile,
                          Remarks: `Wishlist Enquiry For Project - ${data?.Society} `,
                        },
                      ];

                      PostRecords(425, 1, enqBody, (data) => {
                        if (data.hasErrors === false) {
                          toast.success("Enquiry Sent Successfully");
                        } else {
                          toast.error("Error in sending Enquiry");
                        }
                      });
                    }

                    addtoWishlist_Projects(data, wishlist, setWishlist);
                  }
                }}
                style={{
                  color: isWishlisted(data) ? "red" : "#ccc",
                }}
                className="ri-heart-fill"
              />
            </span>
          </div>
          <div className="chipps">
            <span className="property-status">Under Construction</span>
            <span className="property-condo">RERA</span>
          </div>
        </div>
        <div className="property-info">
          <h3>
            <a href="#">{data.Society}</a>
          </h3>
          <p className="developer devs">by {data.DeveloperName}</p>
          <p>
            <i className="flaticon-location" />
            {data.City}, {data.Area}
          </p>

          {/* <div className="headss">
            <ul
              className="property-metainfo list-style lst1"
              style={{ marginTop: 10, whiteSpace: "nowrap" }}
            >
             {Array.isArray(data?.PropertyAmenities) &&
                data?.PropertyAmenities?.length > 0 &&
                data?.PropertyAmenities?.slice(0, 3)?.map((amenity, index) => (
                  <li key={index}>
                    <img
                      src={amenity?.PropertyAmenitiesIcon}
                      alt="Furniture"
                      style={{ height: 20, width: 20 }}
                      // className="furnishing-icon"
                    />
                   
                  </li>
                ))}
            </ul>
          
          </div> */}
          <div className="property-status-wrap">
            <p className="property-price">₹ {data.PriceRange} </p>
            <span className="property-status">{formatDaysAgo(data.cDt)}</span>
          </div>
          <a onClick={handleNavigate} className="btn style1">
            View Details
          </a>
        </div>
      </div>
    </div>
  );
};

export default ProjectsComp;
